import React from 'react';

const QuoteDisclaimer = () => (
  <div className="cmp-quote__disclaimer">
    <p>
      *No carry outs. Additional fees and charges may apply. See store for details
    </p>
    <p>
      **This quote is valid for 7 days after the quote was generated, only at
      your selected location.
    </p>
    <p>
      ***Deals will only be applied during the promotion valid dates.
    </p>
  </div>
);

export { QuoteDisclaimer };
